'use client'
import { useAds } from '@/shared/revive-ads/ads-context'
import { useEffect } from 'react'

declare global {
  interface Window {
    isAddLoaded: boolean
  }
}

function AdsScript() {
  const { isAdsActive } = useAds()
  useEffect(() => {
    // Check if ads are active
    if (!isAdsActive) return

    // Check if script is already loaded
    if (document.querySelector('script[src*="securepubads.g.doubleclick.net"]')) {
      return
    }

    // Create script element
    const script = document.createElement('script')
    script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
    script.async = true
    script.defer = true
    script.id = 'gpt-script'

    // Handle script load event
    const handleLoad = () => {
      window.isAddLoaded = true
      const event = new CustomEvent('adLoadEvent', { bubbles: true })
      document.dispatchEvent(event)
    }

    script.addEventListener('load', handleLoad)
    document.head.appendChild(script)

    // Cleanup function
    return () => {
      script.removeEventListener('load', handleLoad)
      const existingScript = document.getElementById('gpt-script')
      if (existingScript) {
        existingScript.remove()
      }
      window.isAddLoaded = false
    }
  }, [isAdsActive])

  return null
}

export default AdsScript
